import { render, staticRenderFns } from "./leftHeader.vue?vue&type=template&id=742d9686&"
import script from "./leftHeader.vue?vue&type=script&lang=js&"
export * from "./leftHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports